import {useEffect} from 'react';

type Config = {
  enabled: boolean;
  node: Window | Document | HTMLElement | null | undefined;
};

export const useMouseMove = (fn: (event: MouseEvent) => void, config: Partial<Config> = {}) => {
  const {enabled} = config;
  const node = config.node || window;
  useEffect(() => {
    if (enabled) {
      const handler = (event: Event) => fn(event as MouseEvent);
      node.addEventListener(`mousemove`, handler);
      return () => {
        node.removeEventListener(`mousemove`, handler);
      };
    }
    return () => {};
  }, [enabled, fn, node]);
};
